import {Injectable} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {distinctUntilChanged, filter, map} from 'rxjs/operators';

import {Breadcrumb} from './breadcrumb';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  // Build your breadcrumb starting with the root route of your current activated route
  constructor(private activatedRoute: ActivatedRoute,
              private router: Router) {
  }

  breadcrumbs$ = this.router.events.pipe(
    filter(event => {
      return event instanceof NavigationEnd;
    }),
    distinctUntilChanged(),
    map(event => {
      return this.buildBreadCrumb(this.activatedRoute.root);
    })
  );

  buildBreadCrumb(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: Array<Breadcrumb> = []): Array<Breadcrumb> {

    // Taken from here, https://github.com/bovandersteene/ngx-breadcrumb
    // but does not necessarily suit our needs, so many changes
    // TODO: Revisit

    // If no routeConfig is available, we are on the root path
    const path = route.routeConfig ? route.routeConfig.path : '';
    const nextUrl = `${url}${path}/`;
    // In the routeConfig the complete path is not available, so we rebuild it each time
    if (route.firstChild) {
      // If we are not on our current path yet, there will be more children to look after, to build our breadcumb
      return this.buildBreadCrumb(route.firstChild, nextUrl, breadcrumbs);
    }

    let newBreadcrumbs = breadcrumbs;

    if (route.routeConfig && route.routeConfig.data && route.routeConfig.data.parents) {
      route.routeConfig.data.parents.forEach(parent => {
          if (parent.data.title) {
            newBreadcrumbs.push({
              label: parent.data.title,
              url: `${parent.path}/`
            });
          }
        }
      );
    }
    let label;
    const titleOverride = route.snapshot.queryParams.title;
    if (titleOverride) {
      label = titleOverride;
    } else if (route.routeConfig && route.routeConfig.data && route.routeConfig.data.title) {
      label = route.routeConfig.data.title;
    }

    if (label) {
      const breadcrumb = {
        label,
        url: nextUrl,
      };
      newBreadcrumbs = [...breadcrumbs, breadcrumb];
    }
    return newBreadcrumbs;
  }

  getBreadcrumbs() {
    return this.breadcrumbs$;
  }
}
